module.exports = __webpack_public_path__ + "static/media/brand4.fe046f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/brand4.png
// module id = 533
// module chunks = 0